import { useQuery } from "@tanstack/react-query";
import { request } from ".";

const categoriesURL = "/web-twinprocms/public/categories";
const scenesURL = "/web-twinprocms/public/scenes";

const hasAuthToken = () => {
  try {
    const stored = localStorage.getItem("Token");
    const parsed = stored ? JSON.parse(stored) : null;
    return Boolean(parsed?.access_token);
  } catch {
    return false;
  }
};

const toList = (payload: any) => (Array.isArray(payload?.data) ? payload.data : []);

export const useGetPublicCategories = (config?: { enabled?: boolean }) => {
  const authed = hasAuthToken();
  const response = useQuery(
    ["public-categories", authed],
    () => request.get(categoriesURL).then(res => toList(res?.data)),
    { enabled: config?.enabled ?? true }
  );

  return {
    ...response,
    data: response?.data ?? [],
  };
};

export const useGetPublicScenes = (config?: { enabled?: boolean }) => {
  const authed = hasAuthToken();
  const response = useQuery(
    ["public-scenes", authed],
    () => request.get(scenesURL).then(res => toList(res?.data)),
    { enabled: config?.enabled ?? true }
  );

  return {
    ...response,
    data: response?.data ?? [],
  };
};
